/* Product card image slider
   Usage: <card-image-slider> with [data-track], [data-prev], [data-next], [data-dot] children.
   Native scroll-snap handles swipe on touch; arrows and dots handle desktop clicks. */
if (!customElements.get('card-image-slider')) {
  class CardImageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.track ? this.track.children : []);
      if (!this.track || this.slides.length < 2) return;

      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;

      this.prevBtn && this.prevBtn.addEventListener('click', (e) => this.onNav(e, -1));
      this.nextBtn && this.nextBtn.addEventListener('click', (e) => this.onNav(e, 1));
      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(i);
        })
      );

      let ticking = false;
      this.track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.syncIndex();
            ticking = false;
          });
        },
        { passive: true }
      );

      this.update();
    }

    onNav(e, dir) {
      e.preventDefault();
      e.stopPropagation();
      this.goTo(this.index + dir);
    }

    goTo(i) {
      const last = this.slides.length - 1;
      if (i < 0) i = last;       // loop back to last
      if (i > last) i = 0;       // loop to first
      this.index = i;
      this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
      this.update();
    }

    syncIndex() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      if (i !== this.index) {
        this.index = i;
        this.update();
      }
    }

    update() {
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
        slide.tabIndex = i === this.index ? 0 : -1;
      });
    }
  }
  customElements.define('card-image-slider', CardImageSlider);
}